export const SET_PERSONAL_DETAILS = 'SET_PERSONAL_DETAILS';
export const setPersonalDetails = (field, value, isAddress) =>{
  return{
    type: SET_PERSONAL_DETAILS,
    field,
    value,
    isAddress,
  }
}